import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MomentTimezonePipeModule } from "app/shared/module/pipe/moment-timezone-pipe.module";
import { VenuePipeModule } from "app/venue/venue-pipe.module";


import {
    ButtonSharedModule,
    IconSharedModule,
} from "pf_styleguide";
import { SplitPaymentsPipeModule } from "../split-payments-pipe/split-payments-pipe.module";
import { SplitPaymentsSuccessComponent } from "./split-payments-success.component";

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        ButtonSharedModule,
        IconSharedModule,
        MomentTimezonePipeModule,
        VenuePipeModule,
        SplitPaymentsPipeModule
    ],
    declarations: [SplitPaymentsSuccessComponent],
    exports: [SplitPaymentsSuccessComponent]
})
export class SplitPaymentsSuccessModule {}
